<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/4" v-for="(shortcut, index) in shortcuts" :key="index"
        v-if="$canAny(shortcut.permissions) || shortcut.permissions.length === 0">
        <router-link :to="shortcut.url">
          <statistics-card-line hideChart class="mb-base" :icon="shortcut.icon" :color="shortcut.color" icon-right
            :statistic="shortcut.name" statisticTitle="" />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import store from '../store/store.js'


export default {
  components: {
    StatisticsCardLine,
  },
  data() {
    return {
      activeItem: 0,
      shortcuts: [
        {
          name: 'Product Orders',
          url: '/pages/customer-product-orders',
          icon: 'BoxIcon',
          color: 'primary',
          permissions: ['view-order'],
        },
        {
          name: 'Project Brief',
          url: '/pages/customer-project-briefs',
          icon: 'CircleIcon',
          color: 'primary',
          permissions: ['view-project-brief'],
        },
        {
          name: 'Sales Quotes',
          url: '/pages/sales-quotes',
          icon: 'FileTextIcon',
          color: 'primary',
          permissions: ['view-sales-quote'],
        },
        {
          name: 'Sample Orders',
          url: '/pages/customer-sample-orders',
          icon: 'FileTextIcon',
          color: 'primary',
          permissions: ['view-sample-order'],
        },
        {
          name: 'Customer Profile',
          url: '/pages/customer-profile',
          icon: 'FileTextIcon',
          color: 'primary',
          permissions: ['view-customer'],
        },
        {
          name: 'Customer Users',
          url: '/pages/supplier-user',
          icon: 'FileTextIcon',
          color: 'primary',
          permissions: ['view-user'],
        },
        {
          name: 'Customer Sites',
          url: '/pages/customer-sites',
          icon: 'FileTextIcon',
          color: 'primary',
          permissions: ['view-site'],
        },
        {
          name: 'Account Credit',
          url: '/pages/customer-account-credit',
          icon: 'FileTextIcon',
          color: 'primary',
          permissions: ['view-account-credit'],
        },
        {
          name: 'Product Contracts',
          url: '/pages/customer-product-contracts',
          icon: 'FileTextIcon',
          color: 'primary',
          permissions: ['view-product-contract'],
        },
        {
          name: 'Credit Notes',
          url: '/pages/credit-notes',
          icon: 'FileTextIcon',
          color: 'primary',
          permissions: ['view-credit-note'],
        },
        {
          name: 'SO Invoices',
          url: '/pages/invoices',
          icon: 'FileTextIcon',
          color: 'primary',
          permissions: ['view-invoice'],
        }
      ],
    }
  },
  mounted() {
    console.log(store.getters.permissions)
  }
}
</script>


<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media(max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

/*! rtl:end:ignore */
</style>
